// ── Card Product Swatches: click to swap image ──

window.__swatchesLoaded = true;
console.log('custom.js loaded');


document.addEventListener('mousedown', function (e) {
  const swatch = e.target.closest('.card-swatch');
  if (!swatch) return;

  const cardId = swatch.dataset.cardId;
  const imageUrl = swatch.dataset.imageUrl;
  if (!imageUrl) return;

  // Update active state
  const container = swatch.closest('.card-product-swatches');
  container.querySelectorAll('.card-swatch').forEach(s => s.classList.remove('card-swatch--active'));
  swatch.classList.add('card-swatch--active');

  // Find the card wrapper and swap the primary image
  const cardWrapper = swatch.closest('.card-wrapper');
  if (!cardWrapper) return;

  const primaryImg = cardWrapper.querySelector('.card__media .media img:first-child');
  if (primaryImg && imageUrl) {
    primaryImg.src = imageUrl;
    // Update srcset to just the new URL to avoid browser reverting
    primaryImg.srcset = imageUrl;
  }
});

// ── Holiday Announcement Bar: auto-hide after deadline ──

(function () {
  // ── CONFIGURE HERE ──────────────────────────────────────────
  var SHOW_AFTER = new Date('2026-10-30T00:00:00-07:00'); // Friday Oct 30, midnight PDT
  var HIDE_AFTER = new Date('2026-11-02T00:00:00-08:00'); // Monday Nov 2, midnight PST
  var SECTION_ID = 'shopify-section-sections--16238716518446__announcement_bar_aAV9wP';
  // ────────────────────────────────────────────────────────────

  function toggleVisibility() {
    var el = document.getElementById(SECTION_ID);
    if (!el) {
  console.warn('Holiday bar: section not found', SECTION_ID);
  return;
}
console.log('Holiday bar found', el);
    var now = new Date();
    if (now >= SHOW_AFTER && now < HIDE_AFTER) {
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', toggleVisibility);
} else {
  toggleVisibility();
}

setInterval(toggleVisibility, 1000);
})();
